import { useEffect, useState } from 'react'
import { useWeb3React } from '@pancakeswap/wagmi'
import BigNumber from 'bignumber.js'
import lockAbi from 'config/abi/candyLock.json'
import { getCandyLockAddress } from 'utils/addressHelpers'
import { publicClient } from 'utils/wagmi'
import { LockData } from '../types'

// Retrieve Lock list
const useLockList = (dependency) => {
  const { account, chainId } = useWeb3React()
  const [lockList, setLockList] = useState<LockData[]>([])
  const candyLockAddress = getCandyLockAddress(chainId)

  useEffect(() => {
    const fetchLockList = async () => {
      const client = publicClient({ chainId })

      const countResult = await client.readContract({
        abi: lockAbi,
        address: candyLockAddress,
        functionName: 'lockCount',
        args: [account]
      })
      const lockCount = Number(countResult)

      const listResult = await client.readContract({
        abi: lockAbi,
        address: candyLockAddress,
        functionName: 'viewLocks',
        args: [account, 0, lockCount],
      })

      // @ts-ignore
      setLockList(listResult.map((data) => ({
        lid: Number(data.lid),
        amount: new BigNumber(data.amount.toString()),
        lockAt: Number(data.lockAt),
        duration: Number(data.duration),
        lastRewardAt: Number(data.lastRewardAt),
        unlocked: data.unlocked,
        nfts: data.nfts
      })))
    }

    if (account) fetchLockList()
    else setLockList([])
  }, [candyLockAddress, account, chainId, dependency])

  return { lockList }
}

export default useLockList
